export default (theme) => {
  const { textColors, backgrounds } = theme.palette;

  return {
    block: {
      backgroundColor: backgrounds.block,
      color: textColors.main,
    },
    textLink: { color: textColors.link },
    userAvatar: {
      height: 26,
      marginRight: 10,
      width: 26,
    },
  };
};
